import { getRegexRulesForField } from "./fieldValidators";

export default function validateSubdomain(subdomain) {
    const errors = [];

    if (!subdomain || typeof subdomain !== "string") {
        return ["A subdomain is required."];
    }

    const subdomainRules = getRegexRulesForField('subdomain');
    subdomainRules.forEach(([ruleName, ruleData]) => {
        try {
            const parsedRule = JSON.parse(ruleData.toString());
            const {regex, errorMessage} = parsedRule;
            if (!new RegExp(regex.toString()).test(subdomain)) {
                errors.push(errorMessage);
            }
        } catch (e) {
            console.error(`Invalid regex or rule in "${ruleName}":`, e);
        }
    });

    return errors;
}